import { useParams } from "react-router-dom";

import MessageDiff from "@/components/DiffPromptTemplate/MessageDiff";
import MetadataDiff from "@/components/DiffPromptTemplate/MetadataDiff";
import {
  DiffViewerVariant,
  PromptBlueprintDiffViewer as RawBlueprintDiffViewer,
} from "@/components/prompts/PromptBlueprintDiffViewer";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { usePrompt, usePromptVersion } from "@/queries";
import { PromptBlueprint } from "@/types";
import { PromptVersion } from "@/types/apiGetters";

interface DiffViewerProps {
  blueprint: PromptBlueprint;
  promptName?: string;
}

const blueprintToVersionLike = (blueprint: PromptBlueprint): PromptVersion =>
  ({
    ...blueprint,
    inference_client_name: blueprint.inference_client_name ?? undefined,
  }) as PromptVersion;

const BlueprintDiffViewer = ({ blueprint: promptVersionData, promptName }: DiffViewerProps) => {
  const params = useParams();
  const { promptId } = params;
  const versionNumber = params.versionId ?? params.versionNumber;
  const promptRegistryId = Number(promptId);
  const promptVersionNumber = Number(versionNumber);
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const activeWorkspaceId = useUser()?.activeWorkspaceId;
  const promptVersionQuery = usePromptVersion(userToken, promptRegistryId, promptVersionNumber);
  const promptQuery = usePrompt(userToken, {
    workspace_id: activeWorkspaceId!,
    prompt_name: promptName!,
  });
  const promptVersion = promptVersionQuery.data || promptQuery.data;
  if (!promptVersion) {
    return null;
  }

  const targetVersion = blueprintToVersionLike(promptVersionData);

  return (
    <div className="flex max-h-96 flex-col gap-3 overflow-y-auto p-3">
      <MetadataDiff sourceVersion={promptVersion} targetVersion={targetVersion} />
      <div className="rounded-md border border-gray-200">
        <MessageDiff
          sourceTemplate={promptVersion.prompt_template}
          targetTemplate={promptVersionData.prompt_template}
        />
      </div>
    </div>
  );
};
export default BlueprintDiffViewer;
export { DiffViewerVariant, RawBlueprintDiffViewer };
